import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
// TEMPORARILY COMMENTED OUT - Notification system disabled
// import { useNotifications } from '../../hooks/useNotifications';
import { ROUTES } from '../../constants';
import Button from '../ui/Button';
import Dropdown from '../ui/Dropdown';
// TEMPORARILY COMMENTED OUT - Notification system disabled
// import NotificationItem from '../notifications/NotificationItem';
import Icon from '../ui/Icon';
import './Header.css';

const Header = ({ onMenuToggle, isSidebarOpen, headerRef }) => {
  const { user, logout } = useAuth();
  // TEMPORARILY COMMENTED OUT - Notification system disabled
  // const { notifications, unreadCount, markAsRead, deleteNotification } = useNotifications();
  const navigate = useNavigate();


  const handleLogout = () => {
    logout();
    navigate(ROUTES.LOGIN);
  };

  const userMenuOptions = [
    {
      value: 'profile',
      label: 'Profile',
      icon: 'person'
    },
    {
      value: 'divider',
      label: '',
      disabled: true
    },
    {
      value: 'logout',
      label: 'Logout',
      icon: 'logout'
    }
  ];

  const handleUserMenuSelect = (value) => {
    switch (value) {
      case 'profile':
        navigate(ROUTES.PROFILE);
        break;
      case 'logout':
        handleLogout();
        break;
      default:
        break;
    }
  };

  const formatRoleName = (role) => {
    if (!role) return 'Site Manager';
    switch (role) {
      case 'SYSTEM_ADMIN':
        return 'System Admin';
      case 'ADMIN':
        return 'Admin';
      case 'MANAGER':
        return 'Site Manager';
      default:
        return role;
    }
  };

  // TEMPORARILY COMMENTED OUT - Notification system disabled
  // const handleMarkAsRead = async (notificationId) => {
  //   await markAsRead(notificationId);
  // };

  // const handleDeleteNotification = async (notificationId) => {
  //   await deleteNotification(notificationId);
  // };
  return (
    <header ref={headerRef} className="header">
      <div className="header-left">
        <button
          className="header-menu-toggle"
          onClick={onMenuToggle}
          aria-label="Toggle sidebar"
        >
          <Icon name="menu" size="medium" />
        </button>

        <Link to={ROUTES.DASHBOARD} className="header-logo">
          <img src="/sks-icons.svg" alt="SKS Pvt" className="header-logo-img" />
          <span className="header-logo-text">Inventory Management</span>
        </Link>
      </div>

      <div className="header-right">

        {/* TEMPORARILY COMMENTED OUT - Notification system disabled */}
        {/* Notifications */}
        {/*
        <div className="header-notifications">
          <button
            className={`header-notification-button ${isNotificationOpen ? 'active' : ''}`}
            onClick={() => setIsNotificationOpen(!isNotificationOpen)}
            aria-label="Notifications"
          >
            <Icon name="notifications" size="small" />
            {unreadCount > 0 && (
              <span className="header-notification-badge">{unreadCount}</span>
            )}
          </button>

          {isNotificationOpen && (
            <div className="header-notification-dropdown">
              <div className="header-notification-header">
                <h3>Notifications</h3>
                <button
                  className="header-notification-clear"
                  onClick={() => setIsNotificationOpen(false)}
                >
                  <Icon name="close" size="small" />
                </button>
              </div>
              <div className="header-notification-list">
            {notifications.length === 0 ? (
              <div className="header-notification-empty">
                No notifications
              </div>
            ) : (
              notifications.slice(0, 5).map((notification) => (
                <NotificationItem
                  key={notification.id}
                  notification={notification}
                  onMarkAsRead={handleMarkAsRead}
                  onDelete={handleDeleteNotification}
                  className="header-notification-item"
                />
              ))
            )}
              </div>
              <div className="header-notification-footer">
                <Link
                  to={ROUTES.NOTIFICATIONS}
                  className="header-notification-view-all"
                  onClick={() => setIsNotificationOpen(false)}
                >
                  View all notifications
                </Link>
              </div>
            </div>
          )}
        </div>
        */}

        {/* User Menu */}
        <div className="header-user">
          <Dropdown
            options={userMenuOptions}
            value=""
            onChange={handleUserMenuSelect}
            placeholder=""
            className="header-user-dropdown"
            searchable={false}
            clearable={false}
            position="right"
          >
            <div className="header-user-info">
              <div className="header-user-avatar">
                {user?.name?.charAt(0) || user?.email?.charAt(0) || 'U'}
              </div>
              <div className="header-user-details">
                <div className="header-user-name">
                  {user?.name || user?.email || 'User'}
                </div>
                <div className="header-user-role">
                  {formatRoleName(user?.role)}
                </div>
              </div>
              <Icon name="keyboard_arrow_down" size="small" />
            </div>
          </Dropdown>
        </div>
      </div>
    </header>
  );
};

export default Header;
